module.exports = __webpack_public_path__ + "img/beida.ac01133d.png";